<template>
  <div id="base-input">
    <span class="base-input-title" v-if='isTitle'>{{title}}:</span>
    <div class="base-input-box" :style="{width: width}">
      <el-input
      v-bind="$attrs"
      v-on="$listeners"
      placeholder="请输入"
      clearable></el-input>
    </div>

  </div>
</template>

<script>

export default {
  name: 'searchBar',
  components: {},
  props: {
    title: {
      type: String,
      default: '关键词',
    },
    width: {
      type: String,
      default: '149px',
    },
    isTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    // keyValue: {
    //   get () {
    //     return this.$store.state.eventList.keyValue
    //   },
    //   set (keyValue) {
    //     this.$store.commit('eventList/setSearchData', { keyValue })
    //   },
    // },
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
@import '../assets/static/style/common';
#base-input {
  display: inline-block;
  .base-input-title{
    display: inline-block;
    font-size: @ec-font-size-main;
    color: @ec-color-text-main;
    margin-right: 12px;
  }
  .base-input-box{
    display: inline-block;
    input{
      border: 1px solid @ec-color-line-main;
    }
    /deep/ .el-input__inner{
      height: 36px;
      line-height: 36px;
      color: @ec-color-text-main;
      // background-color: transparent;
    }
    /deep/ .el-input.is-active .el-input__inner, /deep/ .el-input__inner:focus{
      border-color: @ec-color-primary;
    }
  }
}
</style>
